import {AxiosResponse} from 'axios';
import {initHttpClient} from '../../../../lib/_requests';
import {
  ClientsResponse,
  ClientSearchParams,
  ClientsQueryResponse,
  ClientFieldQueryResponse,
  ClientResponse,
} from './_models';

export type ID = undefined | null | number;

const API_URL = process.env.REACT_APP_API_URL;
const GET_CLIENTS_URL = `${API_URL}/client/list?${Date.now()}&`;
const GET_CLIENT_CHILDREN_URL = `${API_URL}/client/child/list?${Date.now()}&`;
const SEARCH_CLIENTS_URL = `${API_URL}/client/search?${Date.now()}&`;
const GET_CLIENT_FIELD_BY_ID = `${API_URL}/client/get_field_by_id?${Date.now()}&`;
const GET_CLIENT_BY_ID = `${API_URL}/client/find?${Date.now()}&`;
const CLIENT_CREATE_URL = `${API_URL}/client/create`;

function searchClients(params: ClientSearchParams) {
  const httpClient = initHttpClient();
  return httpClient
    .get(`${SEARCH_CLIENTS_URL}search_key=${params.searchKey}`)
    .then((d: AxiosResponse<ClientsResponse>) => d.data)
    .catch(function (error) {
      console.log('getClients ::: ', error);
      if (error.response) {
        if (error.response.status && error.response.status === 500) {
          window.location.href = `/logout`;
        }

        console.log('error.response ::: ', error.response.status);
      } else if (error.request) {
        console.log('error.request ::: ', error.request);
      } else if (error.message) {
        console.log('error.message ::: ', error.message);
      }
      throw error;
    });
}

const getClients = (query: string): Promise<ClientsQueryResponse> => {
  const httpClient = initHttpClient();

  return httpClient
    .get(`${GET_CLIENTS_URL}${query}`)
    .then((d: AxiosResponse<ClientsQueryResponse>) => d.data)
    .catch(function (error) {
      console.log('getClients ::: ', error);
      if (error.response) {
        if (error.response.status && error.response.status === 500) {
          window.location.href = `/logout`;
        }

        console.log('error.response ::: ', error.response.status);
      } else if (error.request) {
        console.log('error.request ::: ', error.request);
      } else if (error.message) {
        console.log('error.message ::: ', error.message);
      }
      throw error;
    });
};

const getClientChildren = (query: string): Promise<ClientsQueryResponse> => {
  console.log('query ::: ', query);
  const httpClient = initHttpClient();

  return httpClient
    .get(`${GET_CLIENT_CHILDREN_URL}${query}`)
    .then((d: AxiosResponse<ClientsQueryResponse>) => d.data)
    .catch(function (error) {
      console.log('getClients ::: ', error);
      if (error.response) {
        if (error.response.status && error.response.status === 500) {
          window.location.href = `/logout`;
        }

        console.log('error.response ::: ', error.response.status);
      } else if (error.request) {
        console.log('error.request ::: ', error.request);
      } else if (error.message) {
        console.log('error.message ::: ', error.message);
      }
      throw error;
    });
};

const getClientFieldById = (query: string): Promise<ClientFieldQueryResponse> => {
  const httpClient = initHttpClient();

  return httpClient
    .get(`${GET_CLIENT_FIELD_BY_ID}${query}`)
    .then((d: AxiosResponse<ClientFieldQueryResponse>) => d.data)
    .catch(function (error) {
      console.log('getClients ::: ', error);
      if (error.response) {
        if (error.response.status && error.response.status === 500) {
          window.location.href = `/logout`;
        }

        console.log('error.response ::: ', error.response.status);
      } else if (error.request) {
        console.log('error.request ::: ', error.request);
      } else if (error.message) {
        console.log('error.message ::: ', error.message);
      }
      throw error;
    });
};

const getClient = (query: string) => {
  const httpClient = initHttpClient();

  return httpClient
    .get(`${GET_CLIENT_BY_ID}${query}`)
    .then((response: AxiosResponse<ClientResponse>) => response.data)
    .then((response: ClientResponse) => response.data)
    .catch(function (error) {
      if (error.response) {
        if (error.response.status && error.response.status === 500) {
          window.location.href = `/logout`;
        }
        // The request was made and the server responded with a status code
        // that fall s out of the range of 2xx
        let response: any = {};
        response.errors = [];
        if (error.response.data.message) {
          response.errors.push(error.response.data.message);
        } else {
          response = error.response.data;
        }

        throw response;
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        throw error.request;
      } else if (error.message) {
        // Something happened in setting up the request that triggered an Error
        throw error.message;
      }
      throw error;
    });
};

const saveClient = (payload: object) => {
  const httpClient = initHttpClient();

  // return axios
  // .post(`${USER_URL}/${user.id}`, user)
  // .then((response: AxiosResponse<Response<User>>) => response.data)
  // .then((response: Response<User>) => response.data)

  return httpClient
    .post(CLIENT_CREATE_URL, payload)
    .then((response: AxiosResponse<ClientResponse>) => response.data)
    .then((response: ClientResponse) => response.data)
    .catch(function (error) {
      if (error.response) {
        console.log('error.response ::: ', error.response);

        if (error.response.status && error.response.status === 500) {
          window.location.href = `/logout`;
        }

        // The request was made and the server responded with a status code
        // that fall s out of the range of 2xx
        let response: any = {};
        response.errors = [];
        if (error.response.data.message) {
          response.errors.push(error.response.data.message);
        } else {
          response = error.response.data;
        }

        throw response;
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        throw error.request;
      } else if (error.message) {
        // Something happened in setting up the request that triggered an Error
        throw error.message;
      }
      throw error;
    });
};
const updateClient = (payload: object) => {
  console.log(payload);
};
const getClientById = (id: ID) => {
  console.log(id);
};
const deleteSelectedClients = (payload: object) => {
  console.log(payload);
};

const deleteClient = () => {};

export {
  getClientChildren,
  searchClients,
  getClients,
  getClientFieldById,
  saveClient,
  updateClient,
  getClientById,
  deleteSelectedClients,
  deleteClient,
  getClient,
};
